import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast, useToastContainer } from "react-toastify";
import axios from "axios";
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { TableHead, TableRow, TableCell, Table, TableBody, TableSortLabel, TablePagination } from "@material-ui/core";




const EmailTemplates_CMS = () => {

    const [templates, setTemplates] = useState([]);
    const [idList, setIdList] = useState([]);
    const [search, setsearch] = useState("");
    const [searchflag, setsearchflag] = useState(false);
    const [loading, setLoading] = useState(false);
    const [color, setColor] = useState("#000000");

    const [sheet, setSheet] = useState(0);
    const [rowsPerSheet, setRowsPerSheet] = useState(10);

    const [getDelClass, setDelClass] = useState('hideModal');
    const [getMultiDelClass, setMultiDelClass] = useState('hideModal');
    const [delDisable, setDelDisable] = useState(false);
    const [delLoading, setdelLoading] = useState(false)
    const [delcolor, setdelColor] = useState("#FF7E06")
    const [getDelId, setDelId] = useState();

    window.onmousedown = (e) => {
        const modals = document.getElementsByClassName("modal viewModal");
        // console.log("clicked!!! => ", e.target);
        // console.log("modal => ", modals[0]);
        if (modals[0] === e.target) {
            if (getDelClass === 'viewModal')
                setDelClass('hideModal')
            else if (getMultiDelClass === 'viewModal')
                setMultiDelClass('hideModal')
        }
    }

    const handleChangePage = (event, newPage) => {
        setSheet(newPage);
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerSheet(+event.target.value);
        setSheet(0);
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
    };

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    const callback = () => {
        setLoading(false);
        setdelLoading(false);
        setDelDisable(false);
    }

    useEffect(() => {
        setLoading(true);
        fetchTemplates();
    }, [])

    useEffect(() => {
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
    }, [searchflag])

    useEffect(() => {
        if (idList.length !== 0)
            setDelDisable(false);
        else setDelDisable(true)
        const filteredTemplates = templates && templates.filter(template => template.title.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet);
        if (idList.length ? idList.length === templates.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length || idList.length === filteredTemplates.length : false) {
            const checkAllInput = document.getElementById("checkAllInput");
            if (!checkAllInput.checked)
                checkAllInput.checked = true;
        }
    }, [idList])

    useEffect(() => {
        setdata({ ...templates, rows: sortedItems })
    }, [templates])


    useEffect(() => {
        setSheet(0);
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
        if (search === "") { setsearchflag(false) }
        else {
            setsearchflag(true)
        }
    }, [search])

    const fetchTemplates = async () => {
        const response = await axios.request({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            }
            ,
            method: 'get',
            url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-email-templates`
        })
        setTemplates(response.data);
        callback();
    }

    const delList = (check, id) => {
        if (check) {
            // const ifsub = useSelector((state) => state.productDetails.listing.find((cat)));
            // setCategoryProductAssocClass('viewModal')
            setDelClass('viewModal')
            setDelId(id)
        }
    }


    const deleteTemplates = async (id) => {
        // alert(id)
        try {
            setLoading(true);
            setDelDisable(true);
            const response = await axios.request({
                data: { idList: id ? [id] : idList },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                }
                ,
                method: 'post',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/delete-email-template`
            })

            // alert(JSON.stringify(response))
            if (response.data.success) {
                if (id) {
                    toast.success(response.data.message)
                    setTemplates(templates.filter(t => t._id !== id));
                    setDelClass('hideModal');
                }
                else {
                    toast.success(response.data.message)
                    const newTemplates = templates.filter(t => idList.indexOf(t._id) === -1)
                    setTemplates(newTemplates);
                    setIdList([]);
                    setMultiDelClass('hideModal');
                    const checkAllInput = document.getElementById("checkAllInput");
                    if (checkAllInput.checked)
                        checkAllInput.checked = false;
                    const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                    for (let checkBox of checkBoxes1) {
                        if (checkBox.checked)
                            checkBox.checked = false;
                    }
                }
            }
            callback()
        }
        catch (error) {
            toast.success(error)
            callback()
        }

    }

    var defaultSortBy = "createdAt";
    var defaultSortOrder = "desc";
    let [sortBy, setsortBy] = useState(defaultSortBy)             // default sort column
    let [sortOrder, setsortOrder] = useState(defaultSortOrder)    // default sort order

    const sortData = (sortBy, sortOrder, rows) => {
        var itemsToSort = JSON.parse(JSON.stringify(rows || templates));
        var sortedItems = [];
        var compareFn = null;
        switch (sortBy) {
            case "createdAt":
                compareFn = (i, j) => {

                    if (i.createdAt < j.createdAt) {
                        return sortOrder === "desc" ? 1 : -1;
                    } else {
                        if (i.createdAt > j.createdAt) {
                            return sortOrder === "desc" ? -1 : 1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "title":
                compareFn = (i, j) => {

                    if (i.title < j.title) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.title > j.title) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            default:
                break;
        }
        console.log(`---->itemtosort${sortBy}`, itemsToSort)
        sortedItems = templates ? itemsToSort.sort(compareFn) : '';
        console.log('---->sortItems', sortedItems)
        return sortedItems;
    }

    const requestSort = (pSortBy) => {

        var newsortBy = sortBy;
        var newsortOrder = sortOrder;

        console.log('-->newsortBy', newsortBy)
        console.log('-->newsortOrder', newsortOrder)
        console.log('-->pSortBy', pSortBy)

        return event => {
            if (pSortBy === newsortBy) {
                newsortOrder = newsortOrder === "asc" ? "desc" : "asc";
            } else {
                newsortBy = pSortBy;
                newsortOrder = "asc";
            }

            var sortedItems = sortData(newsortBy, newsortOrder);
            setdata({ ...data, rows: sortedItems })
            setsortBy(newsortBy)
            setsortOrder(newsortOrder)
        };
    }
    var sortedItems = sortData(defaultSortBy, defaultSortOrder, templates);

    const [data, setdata] = useState({ ...templates, rows: sortedItems })
    // 


    // setIsSubmitting(true);
    // const callback = () => setIsSubmitting(false);
    // { values: initialValues, callback }
    // console.log(data)
    return (
        <>
            <div className="dashContentHeader">
                <h5 className="dashHeading mb-0">Email Templates</h5>
            </div>
            {/* {console.log("Products", products)} */}
            <div className="dashboardCardRow">
                <div className="input-group mb-4 search-menu">

                    <Link to={'/post-new-email-template'}>   <button className="border-0 sub-button mr-12"> Post New Template </button></Link>
                </div>

                <div className="input-group mb-4 search-menu">
                    <input type="text" className="form-control" onChange={(e) => { setsearch(e.target.value) }} value={search} placeholder="Search templates..." />
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </span>
                    </div>
                    <button className="btn btn-custom-1" onClick={() => { setsearch("") }}>
                        <i class="fa fa-refresh" aria-hidden="true"></i> Reset</button>
                </div>
                <div className="listingTableRow">
                    <div className="listingTableHeader d-flex flex-wrap justify-content-between align-items-center pb-4 ">
                        <div className="custom-control custom-checkbox no-padding">
                            {/* <input type="checkbox" className="custom-control-input" id="checkAllInput" onChange={(event) => {

                                const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                                if (event.target.checked) {
                                    for (let checkBox of checkBoxes1) {
                                        if (!checkBox.checked)
                                            checkBox.checked = true;
                                    }
                                    let tempArray = [];
                                    if (!searchflag) {
                                        templates.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).forEach(page => {
                                            tempArray.push(page._id);
                                        })
                                    }
                                    else {
                                        const filteredPages = templates && templates.filter(template => template.title.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet);
                                        filteredPages.forEach(page => {
                                            tempArray.push(page._id);
                                        })
                                    }
                                    setIdList(tempArray);
                                }
                                else {
                                    for (let checkBox of checkBoxes1) {
                                        if (checkBox.checked)
                                            checkBox.checked = false;
                                    }
                                    setIdList([]);
                                }

                            }} /> */}
                            {/* <label className="custom-control-label" for="checkAllInput">Showing {searchflag ? (templates && templates.filter(template => template.title.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length) : (templates && templates.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length)} templates</label> */}
                            <label className="right-label-checkbox">Showing {searchflag ? (templates && templates.filter(template => template.title.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length) : (templates && templates.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length)} templates
                                <input type="checkbox" className="custom-control-input" id="checkAllInput" onChange={(event) => {

                                    const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                                    if (event.target.checked) {
                                        for (let checkBox of checkBoxes1) {
                                            if (!checkBox.checked)
                                                checkBox.checked = true;
                                        }
                                        let tempArray = [];
                                        if (!searchflag) {
                                            templates.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).forEach(page => {
                                                tempArray.push(page._id);
                                            })
                                        }
                                        else {
                                            const filteredPages = templates && templates.filter(template => template.title.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet);
                                            filteredPages.forEach(page => {
                                                tempArray.push(page._id);
                                            })
                                        }
                                        setIdList(tempArray);
                                    }
                                    else {
                                        for (let checkBox of checkBoxes1) {
                                            if (checkBox.checked)
                                                checkBox.checked = false;
                                        }
                                        setIdList([]);
                                    }

                                }} />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <button className="border-0 deleteButton mr-4" disabled={idList.length > 0 && getDelClass === "hideModal" && getMultiDelClass === "hideModal" ? false : true} style={idList.length === 0 ? { background: "grey" } : {}} onClick={() => setMultiDelClass('viewModal')}>
                                {!loading && <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.33398 3.66667V2.33333C3.33398 1.97971 3.47446 1.64057 3.72451 1.39052C3.97456 1.14048 4.3137 1 4.66732 1H7.33398C7.68761 1 8.02674 1.14048 8.27679 1.39052C8.52684 1.64057 8.66732 1.97971 8.66732 2.33333V3.66667M10.6673 3.66667V13C10.6673 13.3536 10.5268 13.6928 10.2768 13.9428C10.0267 14.1929 9.68761 14.3333 9.33398 14.3333H2.66732C2.3137 14.3333 1.97456 14.1929 1.72451 13.9428C1.47446 13.6928 1.33398 13.3536 1.33398 13V3.66667H10.6673Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.66602 7V11" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.33398 7V11" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>}
                                <span className="mt-1">Delete</span>
                            </button>
                        </div>
                    </div>
                    <div className="table-responsive">

                        <Table className="table customDashboardTable">
                            <TableHead>
                                <TableRow>
                                    <TableCell> <TableSortLabel active={sortBy === "title"} direction={sortOrder} onClick={requestSort("title")}>Template Title </TableSortLabel> </TableCell>
                                    <TableCell>Template Content</TableCell>
                                    <TableCell className="action-col"> Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {loading &&
                                    (
                                        <TableRow >
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell className="action-col"><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                        </TableRow>
                                    )}

                                {!loading && data.rows && data.rows.filter(template => template.title.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).map((template, index) => {



                                    return (
                                        <TableRow key={index}>
                                            <TableCell>
                                                {/* <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input group1" id={`customCheck${index}`} onChange={(event) => {
                                                        if (event.target.checked) {
                                                            setIdList([...idList, template._id]);
                                                        }
                                                        else {
                                                            setIdList(idList.filter(id => id !== template._id));
                                                            const checkAllInput = document.getElementById("checkAllInput");
                                                            if (checkAllInput.checked)
                                                                checkAllInput.checked = false;
                                                        }
                                                    }} />
                                                    <label className="custom-control-label orange" for={`customCheck${index}`}>{template.title}</label>
                                                </div> */}
                                                <label className="right-label-checkbox orange">{template.title}
                                                    <input type="checkbox" className="custom-control-input group1" id={`customCheck${index}`} onChange={(event) => {
                                                        if (event.target.checked) {
                                                            setIdList([...idList, template._id]);
                                                        }
                                                        else {
                                                            setIdList(idList.filter(id => id !== template._id));
                                                            const checkAllInput = document.getElementById("checkAllInput");
                                                            if (checkAllInput.checked)
                                                                checkAllInput.checked = false;
                                                        }
                                                    }} />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </TableCell>
                                            <TableCell dangerouslySetInnerHTML={{ __html: template.templateContent.length >= 50 ? template.templateContent.slice(0, 50) + "..." : template.templateContent }}></TableCell>
                                            <TableCell className="action-col">
                                                {/* <div className="dropdown">
                                                    <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                                            <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                                            <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                                        </svg>
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                        <Link className="dropdown-item" to={`/post-new-email-template/${template._id}`}>Edit</Link>
                                                        <button className="dropdown-item" onClick={() => delList(true, template._id)}>
                                                            Delete
                                                        </button>
                                                    </div>
                                                </div>  */}
                                                <ul className="action-list list-unstyled mb-0 d-flex align-items-center">
                                                    <li>
                                                        <Link to={`/post-new-email-template/${template._id}`} className="fa fa-pencil-square-o"></Link>
                                                    </li>
                                                    <li onClick={() => delList(true, template._id)}>
                                                        <i className="fa fa-trash"></i>
                                                    </li>
                                                </ul>
                                            </TableCell>
                                        </TableRow>)
                                })}

                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
                            component="div"
                            count={data.rows ? data.rows.filter(template => template.title.toLowerCase().includes(search.toLowerCase())).length : 0}
                            rowsPerPage={rowsPerSheet}
                            page={sheet}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />

                    </div>
                </div>
            </div>

            <div id="delModal" className={`modal ${getDelClass}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header px-4">
                            <h5 className="modal-title">Delete List Item</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setDelClass('hideModal') }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-padding">
                            <div className="text-center d-flex flex-column delete-modal">
                                <div>
                                    <h6 className="text-uppercase">Are you sure you want to delete this item ?</h6>
                                </div>
                                <div>
                                    <button className="btn btn-custom mr-2" disabled={delDisable} onClick={() => { setDelClass('hideModal') }}>No</button>
                                    <button className="btn btn-custom" disabled={delDisable} onClick={() => { deleteTemplates(getDelId); setdelLoading(true); setDelDisable(true) }} id="whiteBtn">
                                        {delLoading && <SyncLoader color={delcolor} loading={delLoading} css={override} size={11} />}
                                        {!delLoading && "Yes"}

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="multiDelModal" className={`modal ${getMultiDelClass}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header px-4">
                            <h5 className="modal-title">Delete Selected Items</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setMultiDelClass('hideModal') }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-padding">
                            <div className="text-center d-flex flex-column delete-modal">
                                <div>
                                    <h6 className="text-uppercase">Are you sure you want to delete these selected items ?</h6>
                                </div>
                                <div>
                                    <button className="btn btn-custom mr-2" disabled={delDisable} onClick={() => { setMultiDelClass('hideModal') }}>No</button>
                                    <button className="btn btn-custom" disabled={delDisable} onClick={() => { deleteTemplates(); setdelLoading(true); setDelDisable(true) }} id="whiteBtn">
                                        {delLoading && <SyncLoader color={delcolor} loading={delLoading} css={override} size={11} />}
                                        {!delLoading && "Yes"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmailTemplates_CMS;